import { jsx } from "@emotion/react/jsx-runtime";
import sum from "hash-sum";
const cache = /* @__PURE__ */new WeakMap();
function withDefaultProps(Component, defaultProps, config) {
  let hash = sum({
    defaultProps,
    config
  });
  let cached;
  if (cache.has(Component)) {
    cached = cache.get(Component);
    if (cached[hash]) {
      return cached[hash];
    }
  } else {
    cached = {};
    cache.set(Component, cached);
  }
  let displayName = `WithDefaultProps(${Component.displayName || Component.name || "Component"})`;
  const component = _ref => {
    let {
      ...ownProps
    } = _ref;
    return /* @__PURE__ */jsx(Component, {
      ...defaultProps,
      ...ownProps
    });
  };
  component.displayName = displayName;
  component.wsuiConfig = {
    ...Component.wsuiConfig,
    ...config
  };
  cached[hash] = component;
  return component;
}
export { withDefaultProps as default };